import { useEffect } from 'react'
import { getSocket } from './socketManager'

interface CardMethodVerifiedData {
  storeId?: string | number
  kioskId?: string | number
  storeLabel?: string
  timestamp?: string
  [key: string]: unknown
}

export const useCardMethodVerifiedNotifications = (
  onCardMethodVerified?: (data: CardMethodVerifiedData) => void,
) => {
  useEffect(() => {
    const socket = getSocket()

    const handler = (data: CardMethodVerifiedData) => {
      if (onCardMethodVerified) onCardMethodVerified(data)
    }

    socket.on('card-method-verified', handler)

    return () => {
      socket.off('card-method-verified', handler)
    }
  }, [onCardMethodVerified])
}
